'use client';
import type {
  ProductListV2,
  ProductMembership,
} from '@lib/types/api/ProductListV2';
import { createContext, useContext } from 'react';

export type { ProductInfo } from './productListsHelpers';

export type ProductListsContextValue = {
  personalLists: ProductListV2[];
  orgLists: ProductListV2[];
  isLoading: boolean;
  isProductInList: (productId: string) => boolean | null;
  toggleProductList: (product: { id: string; name: string }) => void;
  fetchProductMembership: (
    productId: string
  ) => Promise<ProductMembership | null>;
  fetchBatchProductMembership: (productIds: string[]) => Promise<void>;
  removeListFromMembershipCache: (listId: string) => Promise<void>;
};

export const ProductListsContext =
  createContext<ProductListsContextValue | null>(null);

const DEFAULT_CONTEXT: ProductListsContextValue = {
  personalLists: [],
  orgLists: [],
  isLoading: false,
  isProductInList: () => null,
  toggleProductList: () => undefined,
  fetchProductMembership: () => Promise.resolve(null),
  fetchBatchProductMembership: () => Promise.resolve(),
  removeListFromMembershipCache: () => Promise.resolve(),
};

export const useProductLists = () => {
  const context = useContext(ProductListsContext);
  return context ?? DEFAULT_CONTEXT;
};
